import {Route} from 'react-router-dom'
import { BrowserRouter } from "react-router-dom"
import Landing from './components/LandingPage/Landing';
import WebService from './components/Project/WebService';
import MobileService from './components/MobileDevService/mobileDevService';
import BlockChainDev from './components/BlockChain/BlockChainDev';
import ContactUS from './components/ContactUs/ContactUs';
import SearchEngineService from './components/SearchEngineOptService/SearchEngine';
import UI from './components/UI/UI.js';
import QA from './components/QA/QA';
import AboutUs from './components/AboutUs/AboutUs';
function App() {
  return (
    <div >
        <BrowserRouter>
   <Route exact path='/' component={WebService}/>
   <Route exact path='/search-engine-optimization-service' component={SearchEngineService}/>
   <Route exact path='/mobile-dev-service' component={MobileService}/>
   <Route exact path='/ui-service' component={UI}/>
   <Route exact path='/qa-service' component={QA}/>
   <Route exact path='/block-chain-dev-service' component={BlockChainDev}/>
   <Route exact path='/contact-us' component={ContactUS}/>
   <Route exact path='/about-us' component={AboutUs}/>
   </BrowserRouter>
    </div>
  );
}

export default App;
